import { FC } from "react";
import Orders, { Order } from "./Orders";

const OrdersWithData: FC = () => {
  const data: Order[] = [];
  return <Orders orders={data} />;
};

export default OrdersWithData;
